'use strict';

function AdminCreateUserController($modal, userService, $translate, adminUserService, $route) {
  var vm = this;
  vm.$onInit = $onInit;
  vm.createUser = createUser;
  vm.loading = false;
  vm.translationsDone = false;

  function $onInit() {
    vm.user = {};
    userService.getGroups().then(function (groups) {
      vm.groups = groups.filter(function (group) {
        return group.name !== 'Cenceo Coworker';
      });
      $translate('groups').then(function () {
        vm.translationsDone = true;
      });
    });
  }

  function createUser(user) {
    vm.loading = true;

    adminUserService.create(user)
      .then(function () {
        $modal({template: require('./success.modal.tpl.html'), show: true});
      })
      .catch(function () {
        $modal({template: require('./failed.modal.tpl.html'), show: true});
      })
      .finally(function () {
        vm.loading = false;
        $route.reload();
      });
  }
}

module.exports = AdminCreateUserController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/create/create.controller.js
 ** module id = 153
 ** module chunks = 0
 **/